import { useNavigate, useParams } from "react-router-dom";
import { ProfilePayload } from "../models/userModels";

/** После полной перезагрузки страницы нет location.state — переносим from для Confirmation */
export const PENDING_AUTH_FROM_KEY = "pending_auth_from";

/**
 * Опции для навигации по сценарию «Купить подписку DEVI».
 * Используется в баннере DEVI, тарифах и других местах.
 */
export interface UseNavigateToDeviSubscribeOptions {
    profile?: ProfilePayload | null;
    /** Вызов при клике «Купить подписку» от заказчика (показать модалку выхода и т.п.) */
    onCustomerBuyClick?: (() => void) | null;
}

/**
 * Хук возвращает обработчик перехода по сценарию «Купить подписку DEVI»:
 * 1. Если передан onCustomerBuyClick — вызывается он (для заказчика).
 * 2. Если пользователь не авторизован как специалист — переход на /specialist/auth с state.from = "devi_subscribe".
 * 3. Иначе — переход на /specialist/lk/advertisement с state.openType = "posts".
 */
export function useNavigateToDeviSubscribe(
    options: UseNavigateToDeviSubscribeOptions = {}
): () => void {
    const navigate = useNavigate();
    const { currentLanguage } = useParams<{ currentLanguage?: string }>();
    const lang = currentLanguage ?? "el";
    const isAuthorizedSpecialist = options.profile?.user_role === "specialist";

    return () => {
        if (options.onCustomerBuyClick) {
            options.onCustomerBuyClick();
            return;
        }
        if (!isAuthorizedSpecialist) {
            navigate(`/${lang}/specialist/auth`, {
                state: { from: "devi_subscribe" },
            });
            return;
        }
        navigate(`/${lang}/specialist/lk/advertisement`, {
            state: { openType: "posts" },
        });
    };
}
